module.exports = __webpack_public_path__ + "static/media/homeMain.1c74fc0b.png";